import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-dashboard-feedback",
  templateUrl: "./dashboard-feedback.component.html",
  styleUrls: ["./dashboard-feedback.component.css"],
})
export class DashboardFeedbackComponent implements OnInit {
  showDataMainDashboard = false;
  showMsgMainDashboard = false;
  showCountryMainDashboard = false;
  showMsgCountryMainDashboard = false;
  showTrunkMainDashboard = false;
  showMsgTrunkMainDashboard = false;
  showGatewayMainDashboard = false;
  showMsgGatewayMainDashboard = false;
  showCAPMainDashboard = false;
  showMsgCAPMainDashboard = false;
  showProjectMainDashboard = false;
  showMsgProjectMainDashboard = false;
  showGlobalCountryMainDashboard = false;
  showMsgGlobalCountryMainDashboard = false;
  showFeedbackMainDashboard = false;
  showMsgFeedbackMainDashboard = false;
  globalAdmin = false;
  regAdmin = false;

  public Country; // = MYCASService.country;
  public DeviceTypeList: any[];
  public Device;
  public ErrorMessage;
  public Countries: any[];
  public LoginEnterpriseID = "srinivas.ganiga";
  public successfulData: any = [];
  public text;
  public options;
  public dataDashboard: any[];
  public labelsDashboard;
  public optionsGatewayDashboard;
  public dataGatewayDashboard;
  public labelsGatewayDashboard;
  public optionsCAPDashboard;
  public dataCAPDashboard;
  public labelsCAPDashboard;
  public optionsProjectDashboard;
  public dataProjectDashboard;
  public labelsProjectDashboard;
  public optionsGlobalCountryDashboard;
  public dataGlobalCountryDashboard;
  public labelsGlobalCountryDashboard;
  public optionsTrunkDashboard;
  public optionsCountryDashboard;
  public dataCountryDashboard;
  public labelsCountryDashboard;
  public dataTrunkDashboard;
  public labelsTrunkDashboard;
  public dlstCountryModel;
  public filter;
  public dlstProjectNameModel;
  public Projects;

  constructor(
    private router: Router,
    private capservice: CAPService,
    private _avRoute: ActivatedRoute
  ) {
    //this.LoginEnterpriseID = capservice.enterpriseid;
    //this.Country = capservice.country;
  }

  ngOnInit(): void {
    $(document).ready(function () {
      if ($("#feedbackDisp").length > 100) {
        $(".comment").shorten({});
      }
    });

    this.successfulData = {};

    this.DeviceTypeList = [
      //{ name: 'Skype', },
      { name: "Cisco" },
      { name: "Teams" },
    ];
    this.ErrorMessage =
      "We didn't find any calls to display for this month. Please contact the Online support or check User Guidelines section for any access or tool issue.";
    this.InitialLoad();
  }

  //initial loading

  InitialLoad() {
    this.capservice.getEntId().subscribe((data) => {
      this.LoginEnterpriseID = data[0].EnterpriseID;
      this.Country = data[0].Country.replace(/^\s+|\s+$/gm, "");

      //$rootScope._Country = this.Country;

      // //mycalls dashboard
      // this.capservice.GetDashboard('Teams', this.LoginEnterpriseID, 'N', this.Country, 'MainDashboard').subscribe(data => {
      //     if (data.length > 0) {
      //         this.successfulData = { mainDashboard: data, selected: {} }
      //         this.text = 'My Calls';
      //         this.options = {
      //             title: {
      //                 display: true,
      //                 fontColor: '#fc8213',
      //                 fontSize: 20,
      //                 text: this.text
      //             }
      //         };

      //         this.dataDashboard = [];
      //         this.labelsDashboard = [];
      //         for (var i = 0; i < data.length; i++) {
      //             if ((data[i].CallType) != null) {
      //                 this.dataDashboard.push(data[i].Cost);
      //                 this.labelsDashboard.push(data[i].CallType);
      //             }
      //             else {
      //                 this.dataDashboard = ['0'];
      //                 this.labelsDashboard = 'No data Available';
      //             }
      //         }
      //         this.showDataMainDashboard = true;
      //         this.showMsgMainDashboard = false;
      //     }
      //     else {
      //         this.showDataMainDashboard = false;
      //         this.showMsgMainDashboard = true;
      //     }
      // })

      //Access load
      this.capservice
        .GetDashboard(
          "N",
          this.LoginEnterpriseID,
          "N",
          this.Country,
          "AccessCheck"
        )
        .subscribe((data) => {
          if (data.length > 0) {
            if (data[0].Access == "Global") {
              this.globalAdmin = true;
              this.regAdmin = false;
            } else {
              this.globalAdmin = false;
              this.regAdmin = true;
            }
          }
        });

      //Feedback dashboard
      this.capservice
        .GetDashboard(
          "N",
          this.LoginEnterpriseID,
          "N",
          "N",
          "FeedbackDashboard"
        )
        .subscribe((data) => {
          if (data.length > 0) {
            this.showFeedbackMainDashboard = true;
            this.showMsgFeedbackMainDashboard = false;
            this.successfulData = { feedbacks: data, selected: {} };
          } else {
            this.showFeedbackMainDashboard = false;
            this.showMsgFeedbackMainDashboard = true;
          }
        });
    });
  }
}
